import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AboutState {
  value: string;
}

const initialState: AboutState = {
  value: 'This is the About page content.',
};

export const aboutSlice = createSlice({
  name: 'about',
  initialState,
  reducers: {
    setAboutContent: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export default aboutSlice.reducer;
